import { useTranslation } from "react-i18next";
import { Select } from "../../fields/base/Select";

const SearchFilter = ({ selectedSearchId, shelfData, selectedShelf, filterSearchId }) => {
  const { t } = useTranslation(["merchandising"]);
  const shelf = shelfData.find((s) => s.id === selectedShelf);
  const defaultOptions = [
    {
      label: t(($) => $.merchandising["All Keywords"]),
      value: "all",
    },
  ];
  const options = defaultOptions.concat(
    shelf?.searches?.map((s) => ({
      label: s.display || s.value,
      value: s.id,
    })) ?? [],
  );
  return (
    <Select
      items={options}
      selectedKey={selectedSearchId === null ? "all" : selectedSearchId}
      onSelectionChange={(v) => filterSearchId(v === "all" ? null : v)}
      css={{ maxWidth: "200px" }}
      aria-label={t(($) => $.merchandising["Select keyword"])}
    />
  );
};

export default SearchFilter;
